/* eslint-disable */
<template>
  <div>
    <div class="container-fluid w-100 no-padding">
      <div class="row bg-primary-dark">
        <div class="col-md-8 mb-2 mt-2 align-middle">
          <h4>Kargo Takibi</h4>
        </div>
        <div class="col-md-4 mb-2 mt-2">
          <button class="btn btn-more-radius btn-success float-right mr-2" data-toggle="modal" data-target="#uetdsModal">Yeni Kayıt Ekle</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <v-wait for="teklifler-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Veriler yükleniyor...</p>
              </div>
            </template>
            <table class="table table-bordered table-striped table-hover">
              <thead class="thead-light">
                <tr>
                  <th style="width: 32px;" scope="col">#</th>
                  <th style="width: 5%;" scope="col">TARİH</th>
                  <th style="width: 10%;" scope="col">ALICI/GÖNDERİCİ</th>
                  <th style="width: 10%;" scope="col">ARAS KARGO</th>
                  <th style="width: 10%;" scope="col">GELEN/GİDEN</th>
                  <th style="width: 10%;" scope="col">ÖDEME</th>
                  <th style="width: 10%;" scope="col">TUTAR</th>
                  <th style="width: auto;" scope="col">AÇIKLAMA</th>
                  <th style="width: 10%;" scope="col">KAYDEDEN</th>
                  <th style="width: 15%;" scope="col">KOMUTLAR</th>
                </tr>
              </thead>
              <tbody class="tbody-margin">
                <template v-for="(cargo, index) in cargos">
                  <tr :key="'trow-first-' + cargo.index">
                    <td class="align-middle text-center">{{index + 1}}</td>
                    <td class="align-middle text-center">{{formatDate(cargo.DATE)}}</td>
                    <td class="align-middle text-center">{{cargo.RECIPIENT_SENDER}}</td>
                    <td class="align-middle text-center">{{isArasKargo(cargo.POST_COMPANY)}}</td>
                    <td class="align-middle text-center">{{isSentOrIncoming(cargo.SENT)}}</td>
                    <td class="align-middle text-center">{{isPaid(cargo.PAID, cargo.SENT)}}</td>
                    <td class="align-middle text-center">{{cargo.AMOUNT}}</td>
                    <td class="align-middle text-center">{{cargo.DESCRIPTION}}</td>
                    <td class="align-middle text-center">{{cargo.PERSONEL_NAME}}</td>
                    <td class="align-middle">
                      <button class="btn btn-sm btn-more-radius btn-primary" data-toggle="modal"
                        data-target="#uetdsModal" @click="selectCargo(index)">Güncelle</button>
                      <button class="btn btn-sm btn-more-radius btn-danger" data-toggle="modal" 
                        data-target="#uetdsDeleteConfirmation" @click="selectCargo(index)">Sil</button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </v-wait>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="uetdsModal" tabindex="-1"
      role="dialog" aria-labelledby="uetdsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uetdsModalLabel">Kargo Kaydı Ekleyin/Güncelleyin</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="cargo-inserting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Kargo Kaydediliyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="customerTitle">TARİH</label>
                    <datepicker :bootstrap-styling="true" v-model="newCargo.date" :format="dateFormatter"></datepicker>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="customerTitle">ALICI / GÖNDERİCİ</label>
                    <input type="text" class="form-control" v-model="newCargo.recipientSender" id="customerTitle">
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 mb-3">
                    <label for="vehicleName">ARAS KARGO?</label>
                    <select class="form-control" v-model="newCargo.postCompany" id="vehicleName">
                      <option value="true">Evet</option>
                      <option value="false">Hayır</option>
                    </select>
                  </div>
                  <div class="col-6 mb-3">
                    <label for="vehicleId">GELEN / GİDEN</label>
                    <select class="form-control" v-model="newCargo.sent" id="vehicleId">
                      <option value="true">Giden</option>
                      <option value="false">Gelen</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 mb-3">
                    <label for="wsUser">ÖDENDİ</label>
                    <select class="form-control" v-model="newCargo.paid" id="wsUser">
                      <option value="true">Evet</option>
                      <option value="false">Hayır</option>
                    </select>
                  </div>
                  <div class="col-6 mb-3">
                    <label for="wsPassword">TUTAR</label>
                    <input type="text" class="form-control" v-model="newCargo.amount" id="wsPassword">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="wsDesc">AÇIKLAMA ve ya GİDEN - GELEN ÜRÜNLER</label>
                    <textarea rows="5" class="form-control" v-model="newCargo.description" id="wsDesc"></textarea>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="addCargo()" class="btn btn-success">Kargoyu Ekle/Güncelle</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="uetdsDeleteConfirmation" tabindex="-1"
      role="dialog" aria-labelledby="uetdsDeleteConfirmationLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uetdsDeleteConfirmationLabel">Kargo Kaydını Sil</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="cargo-deleting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Kargo Kaydı Siliniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <div class="alert alert-danger" role="alert">
                      Seçili kargo kaydını silmek istediğinizden emin misiniz?
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="customerTitle">TARİH</label>
                    <input type="text" disabled class="form-control" :value="formatDate(newCargo.date)" id="customerTitle">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="customerTitle">ALICI / GÖNDERİCİ</label>
                    <input type="text" disabled class="form-control" :value="newCargo.recipientSender" id="customerTitle">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="vehicleName">ARAS KARGO?</label>
                    <select type="text" disabled class="form-control" v-model="newCargo.postCompany" id="vehicleName">
                      <option value="true">Evet</option>
                      <option value="false">Hayır</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="vehicleId">GELEN / GİDEN</label>
                    <select type="text" disabled class="form-control" v-model="newCargo.sent" id="vehicleId">
                      <option value="true">Giden</option>
                      <option value="false">Gelen</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="wsUser">ÖDENDİ</label>
                    <select type="text" disabled class="form-control" v-model="newCargo.paid" id="wsUser">
                      <option value="true">Evet</option>
                      <option value="false">Hayır</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="wsPassword">TUTAR</label>
                    <input type="text" disabled class="form-control" v-model="newCargo.amount" id="wsPassword">
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="deleteCargo()" class="btn btn-danger">Kaydı Sil</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'CargoTracking',
  components: {
    Datepicker
  },
  data () {
    return {
      messageText: '',
      selectedCargoId: 0,
      selectedCargo: {},
      newCargo: {
        id: 0,
        date: '',
        recipientSender: '',
        sent: false,
        paid: false,
        postCompany: true,
        amount: 0,
        description: ''
      },
      cargos: [],
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      },
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
  },
  methods: {
    dateFormatter(date) {
      console.log(date);
      return moment(date).format('DD.MM.YYYY')
    },
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY');
    },
    isArasKargo(postCompany) {
      return postCompany ? 'Evet' : 'Hayır';
    },
    isSentOrIncoming(sent) {
      return sent ? 'Giden' : 'Gelen';
    },
    isPaid(paid, sent) {
      if(sent) {
        return paid ? 'Lenoi Ödemeli' : 'Alıcı Ödemeli';
      } else {
        return paid ? 'Alıcı Ödemeli' : 'Lenoi Ödemeli';
      }
    },
    getCargos() {
      this.$wait.start('cargos-loading');

      axios
      .get('/api/cargotracking')
      .then(response => {
        this.cargos = response.data
        this.$wait.end('cargos-loading')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('cargos-loading')
      })
    },
    addCargo() {
      this.$wait.start('cargo-inserting');

      console.log("before", this.newCargo)

      this.newCargo.date = moment(this.newCargo.date).format('YYYY-MM-DD');
      this.newCargo.postCompany = this.newCargo.postCompany == "true";
      this.newCargo.sent = this.newCargo.sent == "true";
      this.newCargo.paid = this.newCargo.paid == "true";
      this.newCargo.amount = this.newCargo.amount + '';

      console.log("after", this.newCargo)

      axios
      .post('/api/cargotracking', this.newCargo)
      .then(response => {
        this.$wait.end('cargo-inserting')
        this.getCargos()
        this.newCargo.id = 0
        this.newCargo.recipientSender = ''
        this.newCargo.sent = false
        this.newCargo.amount = '0',
        this.newCargo.paid = false
        this.newCargo.postCompany = true
        this.newCargo.description = ''
        this.newCargo.date = ''
        $('#uetdsModal').modal('hide')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('cargo-inserting')
      })
    },
    deleteCargo() {      
      axios
      .delete('/api/cargotracking/' + this.selectedCargoId)
      .then(response => {
        this.$wait.end('cargo-deleting')
        this.getCargos()
        this.newCargo.id = 0
        this.newCargo.recipientSender = ''
        this.newCargo.sent = false
        this.newCargo.amount = '0',
        this.newCargo.paid = false
        this.newCargo.postCompany = true
        this.newCargo.description = ''
        this.newCargo.date = ''
        $('#uetdsDeleteConfirmation').modal('hide')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('cargo-deleting')
      })
    },
    selectCargo(index) {
      this.selectedCargoId = this.cargos[index].ID
      this.selectedCargo = this.cargos[index]

      this.newCargo.id = this.selectedCargo.ID
      this.newCargo.recipientSender = this.selectedCargo.RECIPIENT_SENDER
      this.newCargo.sent = this.selectedCargo.SENT
      this.newCargo.amount = this.selectedCargo.AMOUNT
      this.newCargo.paid = this.selectedCargo.PAID
      this.newCargo.postCompany = this.selectedCargo.POST_COMPANY
      this.newCargo.description = this.selectedCargo.DESCRIPTION
      this.newCargo.date = this.selectedCargo.DATE
    },
  },
  mounted() {
    this.getCargos()
  }
}
</script>

<style scoped>

  div.icon-global {
    position: absolute;
    z-index: 3;
    margin-left: -36px;
    margin-top: 24px;
    width: 30px;
    height: 30px;
    padding: 4px 4px 5px 4px;
    border-radius: 15px;
  }

  div.icon-global.bg-danger {
    margin-top: -6px !important;
  }

  div.icon-global i {
    color: #FFF;
  }

  .margin-negative {
    margin-bottom: -4px !important;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table { caption-side: top !important; }
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: 0.875rem;
  }

  td a.btn {
    font-size: .875rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

  .text-truncated {
    display: block !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/CargoTrackingPage.vue